import type {
  ChipColors,
  ChipTypes,
} from 'components-stateless/DesignSystem/Atoms/Chip/types';
import type { FieldType } from 'containers/Ticketing/TicketFields/types';

export enum TabOptions {
  DataTable = 'Data Table',
  Visualization = 'Visualization',
  Filters = 'Filters',
}

export interface DatatableFieldFilterOption {
  label: string;
  value: string;
  metadata?: {
    color?: ChipColors;
    chipType?: ChipTypes;
  };
}

export interface DatatableFieldFilterOptionGroup {
  groupName: string;
  groupId: string;
  sequence: number;
  options: DatatableFieldFilterOption[];
}

export interface DatatableField {
  id: string;
  originalName: string;
  type: FieldType;
  label: string;
  position: number;
  includeTime?: boolean;
  filterOptions?:
    | DatatableFieldFilterOption[]
    | DatatableFieldFilterOptionGroup[];
  comparatorNum?: string;
  comparatorUnit?: string;
}

export interface DatatableSort {
  sortBy: string;
  orderBy: 'asc' | 'desc';
}

export enum StaticFieldFilter {
  BOARDS = 'Boards',
  MATTER_LAYOUT = 'Matter Layout',
}
export interface FilterField {
  id: string;
  label: string;
  value: string | string[];
  type: FieldType;
  options?: DatatableFieldFilterOption[] | DatatableFieldFilterOptionGroup[];
  operator: string;
  comparatorNum?: string;
  comparatorUnit?: string;
}

export enum FilterSatisfies {
  ALL = '1',
  ANY = '2',
}

export enum ChartTypes {
  LIST = 'list',
  BAR = 'bar',
  LINE = 'line',
  PIE = 'pie',
  METRIC = 'metric',
}

export enum ChartPeriod {
  DAILY = 'day',
  WEEKLY = 'week',
  MONTHLY = 'month',
  QUARTERLY = 'quarter',
  YEARLY = 'year',
}

export interface ChartXAxis {
  id: string;
  type: FieldType;
  period?: ChartPeriod | null;
}

export enum ChartFormula {
  COUNT = 'count',
  SUM = 'sum',
  AVERAGE = 'average',
  MIN = 'min',
  MAX = 'max',
}

export interface ChartYAxis {
  measure: string;
  formula: ChartFormula;
}

export enum ChartSort {
  No_Axis = 'noaxis',
  X_Axis = 'x',
  Y_Axis = 'y',
}

export enum ChartDisplayOption {
  ALL = 'All',
  MAX_5 = '5',
  MAX_10 = '10',
  MAX_15 = '15',
  MAX_20 = '20',
  MAX_25 = '25',
}

export interface ChartDisplay {
  sort?: ChartSort;
  order?: 'asc' | 'desc';
  displayOption: ChartDisplayOption;
}

export enum BarChartDisplay {
  STACKED = 'stacked',
  SIDE = 'side-by-side',
}

export enum MetricFormattingDisplay {
  NUMBER = 'number', // number
  PERCENTAGE = 'percentage', // number
  CURRENCY = 'currency', // number
  DHM = 'dhm', // time_elapsed
  DH = 'dh', // time_elapsed
  HOURS = 'hours', // time_elapsed
  YEARS = 'years', // duration
  MONTHS = 'months', // duration
  WEEKS = 'weeks', // duration
  DAYS = 'days', // time_elapsed AND duration
}

export enum EntitySourceOperator {
  INCLUDES_ANY_OF = 'includes',
  EXCLUDES_ANY_OF = 'excludes',
}
